angular.module("UI8.components").component("downloadModal", {
  template: `<div class="modal modal--download open" ng-if="$ctrl.display" ng-click="$ctrl.closeModal()">
      <button class="modal__close" ng-click="$ctrl.closeModal()"></button>
      <div class="modal__container">
        <div class="download">
          <div class="download__preview">
            <img ng-src="{{ $ctrl.product.card_image }}" alt="Preview" />
          </div>
          <div class="download__upsell" ng-if="$ctrl.upsell" onclick="event.stopPropagation()">
            <div class="download__upsell-title">{{ $ctrl.upsell.title }}</div>
            <p class="download__upsell-text">{{ $ctrl.upsell.text }}</p>
            <a class="btn btn--green" ng-href="{{ $ctrl.upsell.href }}" ui8-track-event="Freebie,Pass Upsell {{ $ctrl.upsell.kind }}" ui8-upsell-track="{{ $ctrl.upsell.placement }}" upsell-product="{{ $ctrl.product._id }}">{{ $ctrl.upsell.cta }}</a>
          </div>
          <ul class="download__buttons" ng-if="$ctrl.product.files.length && !$ctrl.showVerification && !$ctrl.upsell" onclick="event.stopPropagation()">
            <li ng-repeat='file in $ctrl.product.files track by $index'>
              <button class="btn btn--submit" ng-click="$ctrl.initDownload($index)">
                <span>{{ file.name }}</span>
                <span ng-if="file.size">{{ $ctrl.convertToMb(file.size) }}</span>
                <svg><path fill-rule="evenodd" d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm0 6a1 1 0 0 1 1 1v5.586l2.293-2.293a1 1 0 0 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 1.414-1.414L11 13.586V8a1 1 0 0 1 1-1z"/></svg>
              </button>
            </li>
          </ul>
          <div class="download__remix" ng-if="$ctrl.hasRemix() && !$ctrl.showVerification && !$ctrl.upsell" onclick="event.stopPropagation()">
            <div class="download__remix-head">
              <svg viewBox="0 0 16 16" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM8.63066 4.42754C8.23743 4.21368 7.76257 4.21368 7.36934 4.42754L5.08926 5.66777C4.66445 5.89885 4.40001 6.34376 4.4 6.82734V9.17441C4.4 9.65799 4.66447 10.1029 5.08926 10.334L7.36934 11.5742C7.7626 11.7881 8.2374 11.7881 8.63066 11.5742L10.9107 10.334C11.3355 10.1029 11.6 9.65799 11.6 9.17441V8.79113C11.6 8.46816 11.3203 8.24107 11 8.19941C9.89931 8.05625 9.20004 7.21465 9.2 5.9998C9.2 5.94302 9.20216 5.88674 9.20641 5.83104C9.24741 5.293 9.10466 4.6854 8.63066 4.42754ZM11.5 4.4C10.6716 4.4 10 5.07148 10 5.8998C10 6.72812 10.6716 7.39961 11.5 7.39961C12.3284 7.39961 13 6.72812 13 5.8998C13 5.07148 12.3284 4.4 11.5 4.4Z"/></svg>
              <span>Forge remix link</span>
            </div>
            <button class="btn btn--submit" ng-if="!$ctrl.remixUrl" ng-disabled="$ctrl.remixLoading" ng-click="$ctrl.revealRemix()">
              <span>{{ $ctrl.remixLoading ? 'Getting link…' : 'Get remix link' }}</span>
            </button>
            <div class="download__remix-link" ng-if="$ctrl.remixUrl">
              <input type="text" readonly value="{{ $ctrl.remixUrl }}" onclick="this.select()" aria-label="Forge remix link" />
              <button type="button" ng-click="$ctrl.copyRemix()">{{ $ctrl.remixCopied ? 'Copied' : 'Copy' }}</button>
            </div>
            <p class="download__remix-hint">
              Open in <a ng-href="{{ $ctrl.remixUrl || 'https://forge.ui8.ai' }}" target="_blank" rel="noopener">Forge</a> and hit Remix. Free account required.
            </p>
          </div>
        </div>
      </div>
      <div class="modal__backdrop"></div>
    </div>
    <verification-modal display='$ctrl.showVerification'></verification-modal>`,

  controller: function (DownloadService, FlashService, PushService, $timeout) {
    var ctrl = this;
    // Seconds a freebie waits behind the pass panel before the file starts
    var UPSELL_DELAY = 5;
    var countdownTimer = null;

    ctrl.closeModal = closeModal;
    ctrl.showVerification = false;

    // Forge remix link (helpers/forge-remix.js): shown for products with the
    // Forge platform, revealed on click so pass downloads are counted once
    ctrl.hasRemix = function () {
      var p = ctrl.product;
      return !!(
        window.UI8 &&
        window.UI8.forgeRemix &&
        p &&
        (p.compatibility || []).indexOf("Forge") !== -1
      );
    };

    ctrl.$onChanges = function (changes) {
      if (changes.product) {
        ctrl.remixUrl = null;
        ctrl.remixCopied = false;
        ctrl.upsell = null;
        stopCountdown();
      }
    };

    // Pass upsell on freebies (show.jade passes freebie="true"): clicking a
    // file swaps the list for the pass panel, which counts down UPSELL_DELAY
    // seconds before the file is requested, and turns into the wall when the
    // daily cap (helpers/freebie-limit.js) blocks the claim. Pass holders get
    // the file straight away and never see it. The rel codes land in
    // order.campaign, so the placements can be compared in the orders.
    function hasPass() {
      return !!(
        window.UI8 &&
        (window.UI8.userActivePass || window.UI8.userHasLifetime)
      );
    }

    function upsellText() {
      var count = (window.UI8 && window.UI8.paidProductCount) || 0;
      var products = count
        ? String(count).replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
          " premium products"
        : "every premium product";
      return (
        "Get unlimited access to freebies plus " +
        products +
        " with the All Access Pass."
      );
    }

    function wantsUpsell() {
      return !!ctrl.freebie && !hasPass();
    }

    function stopCountdown() {
      if (countdownTimer) $timeout.cancel(countdownTimer);
      countdownTimer = null;
    }

    ctrl.showUpsell = function (kind, serverMessage) {
      if (!wantsUpsell()) return;
      if (kind === "limit") {
        stopCountdown();
        ctrl.upsell = {
          kind: "Wall",
          placement: "wall",
          title: "That's all for today.",
          text: String(serverMessage || "").replace(
            /^Daily freebie limit reached[.:]?\s*/i,
            ""
          ),
          href: "/products/all-access-pass?rel=freebie-limit",
          cta: "Get unlimited with All Access",
        };
      } else if (kind === "waiting") {
        ctrl.upsell = {
          kind: "Modal",
          placement: "modal",
          title: "Your download starts in " + ctrl.secondsLeft + "s",
          text: upsellText(),
          href: "/products/all-access-pass?rel=freebie-modal",
          cta: "Get All Access",
        };
      } else {
        ctrl.upsell = {
          kind: "Modal",
          placement: "modal",
          title: "Your download is on its way.",
          text: upsellText(),
          href: "/products/all-access-pass?rel=freebie-modal",
          cta: "Get All Access",
        };
      }
    };

    // Freebie click: panel first, file after the countdown
    function delayedDownload(fileIndex, dropbox) {
      if (countdownTimer) return; // one countdown at a time
      ctrl.secondsLeft = UPSELL_DELAY;
      ctrl.showUpsell("waiting");
      var tick = function () {
        ctrl.secondsLeft -= 1;
        if (ctrl.secondsLeft > 0) {
          ctrl.showUpsell("waiting");
          countdownTimer = $timeout(tick, 1000);
          return;
        }
        countdownTimer = null;
        requestDownload(fileIndex, dropbox);
      };
      countdownTimer = $timeout(tick, 1000);
    }

    ctrl.revealRemix = function () {
      ctrl.remixLoading = true;
      DownloadService.getRemix(ctrl.product)
        .then(function (url) {
          ctrl.remixUrl = url;
        })
        .catch(function (err) {
          if (
            /New device/.test(err) &&
            window.UI8 &&
            window.UI8.userHasLifetime
          ) {
            ctrl.showVerification = true;
          } else {
            FlashService.set("error", err);
          }
        })
        .finally(function () {
          ctrl.remixLoading = false;
        });
    };

    ctrl.copyRemix = function () {
      var done = function () {
        ctrl.remixCopied = true;
        $timeout(function () {
          ctrl.remixCopied = false;
        }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(ctrl.remixUrl).then(function () {
          $timeout(done);
        });
      } else {
        var input = document.querySelector(".download__remix-link input");
        if (input) {
          input.select();
          document.execCommand("copy");
          done();
        }
      }
    };

    ctrl.convertToMb = function (bytes) {
      return `(${(bytes / (1024 * 1024)).toFixed(2)}mb)`;
    };

    ctrl.initDownload = function (fileIndex, dropbox) {
      if (wantsUpsell() && !dropbox) return delayedDownload(fileIndex);
      return requestDownload(fileIndex, dropbox);
    };

    function requestDownload(fileIndex, dropbox) {
      DownloadService.get(ctrl.product, fileIndex, dropbox).then(
        function (result) {
          if (dropbox && result) ctrl.dropboxClass = result;
          ctrl.showUpsell("after");
        },
        function (err) {
          console.log("error:", err);
          if (
            /New device/.test(err) &&
            window.UI8 &&
            window.UI8.userHasLifetime
          ) {
            ctrl.display = true;
            ctrl.showVerification = true;
          } else if (/freebie limit/i.test(err) && wantsUpsell()) {
            ctrl.display = true;
            ctrl.showUpsell("limit", err);
          } else {
            ctrl.upsell = null;
            return FlashService.set("error", err);
          }
        }
      );
    }

    function closeModal() {
      ctrl.display = false;
      ctrl.upsell = null;
      stopCountdown();
      initPushNotificationHandler();
    }

    function initPushNotificationHandler() {
      if (!("serviceWorker" in navigator)) return;
      if (!("PushManager" in window)) return;

      PushService.setUpPush()
        .then(function (subscription) {
          if (!subscription) {
            return PushService.subscribe();
          }
        })
        .catch(function () {});
    }
  },

  bindings: {
    product: "<?",
    display: "=?",
    freebie: "<?",
  },
});
